import React, { FC } from 'react';
import { useT } from '@transifex/react';
import Grid from '@mui/material/Grid';
import { Divider } from '@raisin/components-lib';
import { PressReleasePageProps } from 'types';
import getPageContent from 'utils/getPageContent';
import * as S from './styles';
import { ArchiveButton } from './ArchivedButton';

export const PressReleasePageContent: FC<PressReleasePageProps> = ({
  headingData,
  contentData,
  sidebarData,
  pressPageData,
  modelPortfolios,
}) => {
  const t = useT;

  return (
    <S.Container>
      <S.ColumnsGrid container justifyContent="space-between">
        <S.ContentGrid item xs={12} md={8}>
          <ArchiveButton
            position="top"
            url={`${pressPageData?.[0]?.locale}${pressPageData?.[0]?.url}`}
          />
          {headingData.map((headline) => getPageContent(headline, t, modelPortfolios))}
          <Divider light />
          {contentData.map((content, index) => (
            <div className="contentItem" key={index}>
              {getPageContent(content, t, modelPortfolios)}
            </div>
          ))}
          <ArchiveButton
            position="bottom"
            url={`${pressPageData?.[0]?.locale}${pressPageData?.[0]?.url}`}
          />
        </S.ContentGrid>

        <Grid item xs={12} md={4}>
          {sidebarData.map((sidebar) => getPageContent(sidebar, t, modelPortfolios))}
        </Grid>
      </S.ColumnsGrid>
    </S.Container>
  );
};
